import { User } from "../../store/types";
import { formatPhone } from "../../hooks/validation";
import StatusTag from "../StatusTag/StatusTag";
import { ColumnMeta } from "../CustomDatatable/CustomDatatable";
import { OnlineTag, OfflineTag } from "../../styles/PageLayoutStyles.styles";

export const isActivatedBodyTemplate = (rowData: User) => {
  const status: "success" | "danger" = rowData.isActivated
    ? "success"
    : "danger";
  const label = rowData.isActivated ? "Активирован" : "Не активирован";
  return <StatusTag status={status} label={label} />;
};

export const phoneTemplate = (rowData: any) => {
  return formatPhone(rowData?.phone);
};

export const onlineTemplate = (rowData: any) => {
  if (rowData?.isOnline)
    return (
      <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
        <OnlineTag />
        <p style={{ margin: 0 }}>Онлайн</p>
      </div>
    );
  else
    return (
      <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
        <OfflineTag />
        <p style={{ margin: 0 }}>Не онлайн</p>
      </div>
    );
};

export const userColumns: ColumnMeta<User>[] = [
  { field: "fullName", header: "ФИО" },
  { field: "organization", header: "Компания" },
  { field: "licenses", header: "Количество лицензий" },
  { field: "phone", header: "Телефон", body: phoneTemplate },
  { field: "email", header: "Почта" },
  {
    field: "isActivated",
    header: "Активирован",
    body: isActivatedBodyTemplate,
  },
];

export const companyUserColumns: ColumnMeta<User>[] = [
  { field: "fullName", header: "ФИО" },
  { field: "licenses", header: "Количество лицензий" },
  { field: "phone", header: "Телефон", body: phoneTemplate },
  { field: "email", header: "Почта" },
];

export const licenseMembers: ColumnMeta<User>[] = [
  { field: "fullName", header: "ФИО" },
  { field: "isOnline", header: "Онлайн", body: onlineTemplate },
];
